// To detect the browsers that support the SrcSet
export const isSrcSetSupported = () => {
  const img =
    document.getElementsByTagName('img')[0] || document.createElement('img')
  return 'srcset' in img
}
